﻿import { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Spinner } from "react-bootstrap";

import { ReactComponent as BackSvg } from "@/assets/images/desktop/volver.svg";
import { ReactComponent as AddSvg } from "@/assets/images/icons/Estates/add.svg";
import classes from "./head.module.scss";

import { CHANGE_SELECT_INVENTORIES } from "@/redux/types/inventory.types";
import { textConstants } from "@/languages/textConstants";

const Head = (props) => {
	const {
		title,
		input_file,
		name_file,
		uploadFile,
		validFile,
		titles,
		button,
		button_text,
		action,
		back_url,
		button_filter,
		isFetching,
		downloadFile,
		redirectCallback,
		style = {},
	} = props;

	const refFile = useRef(null);

	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();

	const { user } = useSelector((state) => state.auth);

	let fileExtension = "pdf";
	if (name_file === "Excel") {
		fileExtension = ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel";
	}
	if (name_file === "PDF") {
		fileExtension = "pdf";
	}

	const newTitles = titles
		? titles.map((title) => {
				if (title.name === "delivery_text_numero" || title.name === "Guías de Despacho" || title.label === "Guías de Despacho") {
					title.name = textConstants[user.customer.country_id].delivery;
					title.label = textConstants[user.customer.country_id].delivery;
				}

				return title;
			})
		: [];

	return (
		<div className={`no_print ${classes.headMain}`}>
			<div
				className={classes.main_back}
				onClick={() => {
					dispatch({
						type: CHANGE_SELECT_INVENTORIES,
						payload: {
							selected: [],
						},
					});
					back_url ? navigate(back_url) : navigate(-1);
					redirectCallback && redirectCallback();
				}}
			>
				{!["/"].includes(location.pathname) && newTitles && newTitles.length !== 0 && (
					<>
						<BackSvg className={classes.iconBack} />
					</>
				)}
			</div>

			<div className={classes.main_title}>
				<div className={`${classes.title}`}>
					{newTitles && newTitles.length !== 0 ? (
						<>
							{newTitles.map((t, i) => {
								if (Object.prototype.hasOwnProperty.call(t, "customers") && !t.customers.includes(Number(user.customer.id))) {
									return "";
								}

								const fullUrl = location.pathname + decodeURIComponent(location.search);

								return (
									<div
										key={i}
										className={`
										${classes.title_link}
										${fullUrl.includes(decodeURIComponent(t.link)) && classes.active}
										${classes[t.class]}
									`}
										onClick={() => {
											dispatch({
												type: CHANGE_SELECT_INVENTORIES,
												payload: {
													selected: [],
												},
											});
											navigate(t.link);
											redirectCallback && redirectCallback();
										}}
									>
										{t.class ? <span>{t.label}</span> : t.label}
									</div>
								);
							})}
							{isFetching && (
								<Spinner
									style={{
										borderWidth: "0.1em",
										marginLeft: "5px",
									}}
									as="span"
									animation="border"
									size="sm"
									role="status"
									aria-hidden="true"
								/>
							)}
						</>
					) : (
						<div style={{ display: "flex", alignItems: "center" }}>
							<BackSvg
								className={`${classes.iconBack} ${button_filter && classes.button_filter}`}
								onClick={() => {
									dispatch({
										type: CHANGE_SELECT_INVENTORIES,
										payload: {
											selected: [],
										},
									});
									back_url ? navigate(back_url) : navigate(-1);
									redirectCallback && redirectCallback();
								}}
							/>

							<div style={{ marginLeft: "1em" }}>
								{title}
								{isFetching && (
									<Spinner
										style={{
											borderWidth: "0.1em",
											marginLeft: "5px",
										}}
										as="span"
										animation="border"
										size="sm"
										role="status"
										aria-hidden="true"
									/>
								)}
							</div>
						</div>
					)}
				</div>
				{input_file && (
					<div>
						<div
							className={`${classes.buttonFile} ${name_file === "Excel" && classes.Excel} ${name_file === "PDF" && classes.PDF}`}
							onClick={(_e) =>
								validFile ? validFile() && refFile.current && refFile.current.click() : refFile.current && refFile.current.click()
							}
						>
							{`Cargar ${name_file}`}
						</div>
						<input style={{ display: "none" }} type="file" accept={`application/${fileExtension}`} ref={refFile} onChange={(e) => uploadFile(e)} />
					</div>
				)}
				{button && (
					<div style={{ width: "15em" }}>
						<div className={classes.button} onClick={action} style={{ ...style }}>
							<AddSvg className={classes.icon} />
							{button_text ? button_text : ""}
						</div>
					</div>
				)}
				{downloadFile && (
					<div>
						<div
							className={`${classes.buttonFile} ${classes.Download}`}
							onClick={(_e) => window.open(downloadFile, "_blank", "noopener,noreferrer")}
						>
							{`Plantilla`}
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default Head;
